import { render } from "./BankStatementVerification.vue?vue&type=template&id=a98424fa&scoped=true"
import script from "./BankStatementVerification.vue?vue&type=script&lang=js"
export * from "./BankStatementVerification.vue?vue&type=script&lang=js"

import "./BankStatementVerification.vue?vue&type=style&index=0&id=a98424fa&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a98424fa"]])

export default __exports__